import { compose } from 'redux';
import { connect } from 'react-redux';
import { RAN } from '../constants/measure';
import RANDirectionsView from './RANDirectionsView';
import AvatarView from '../common/avatar/avatarView';
import withAvatar from '../common/avatar/withAvatar';
import { getMeasureType } from '../common/utils/urlParsers';
import { goToPractice } from '../common/navigation/navigationActions';

const mapDispatchToProps = (dispatch, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        onNext: () => {
            dispatch(goToPractice(RAN.MEASURE, measureType));
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.HIDDEN,
});

const RANDirectionsContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RANDirectionsView);

export default RANDirectionsContainer;
